// extracted by mini-css-extract-plugin
module.exports = {"button":"a2c79c7e7d--button--F0p8Y"};